export default "__VITE_ASSET__BmfePnfc__"